export const chevronRight = (
  <svg fillRule="evenodd" clipRule="evenodd">
    <path d="M4 .755l14.374 11.245-14.374 11.219.619.781 15.381-12-15.391-12-.609.755z" />
  </svg>
);
